import React, { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router";
import OrganizationSettingsTerminalsDetailsPage from "./pages/Details";
import OrganizationSettingsTerminalsIndexPage from "./pages/Index/pages/Index";

const OrganizationSettingsTerminalsPage: FC<RouteComponentProps> = (props) => {
	return (
		<div className="content">
			<Switch>
				<Route exact path={`${props.match.url}/`} component={OrganizationSettingsTerminalsIndexPage} />
				<Route path={`${props.match.url}/:terminalId`} component={OrganizationSettingsTerminalsDetailsPage} />
			</Switch>
		</div>
	);
};
export default OrganizationSettingsTerminalsPage;
